var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card card-custom",class:_vm.classes},[(_vm.hasTitleSlot || _vm.title)?_c('div',{staticClass:"card-header",class:_vm.headClass},[_c('div',{staticClass:"card-title"},[(_vm.hasTitleSlot)?_vm._t("title"):_vm._e(),(!_vm.hasTitleSlot)?_c('h3',{staticClass:"card-label"},[_vm._v(" "+_vm._s(_vm.title)+" ")]):_vm._e()],2),_c('div',{staticClass:"card-toolbar"},[_vm._t("toolbar")],2)]):_vm._e(),_c('div',{staticClass:"card-body",class:{
    bodyClass: _vm.bodyClass,
    'body-fit': _vm.bodyFit,
    'body-fluid': _vm.bodyFluid
  }},[_vm._t("body")],2),(_vm.hasFootSlot)?_c('div',{staticClass:"card-footer"},[_vm._t("foot")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }